import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';
import { FC } from 'react';
import parse from 'html-react-parser';

import { GuidebookLabelText, GuidebookInfoIcon, GuidebookLabelWrapper, GuidebookTooltip } from './styles';

interface IGuidebookLabelProps {
  label: string;
  fullGuidebookName?: string;
}

export const GuidebookLabelWithIcon: FC<IGuidebookLabelProps> = ({ label, fullGuidebookName }) => {
  const withSuperscript = (text: string) => text.replace(/®/g, '<sup>®</sup>');
  const labelNode = parse(withSuperscript(label));
  const tooltipNode = fullGuidebookName ? parse(withSuperscript(fullGuidebookName)) : null;

  if (!fullGuidebookName) {
    return (
      <GuidebookLabelWrapper>
        <GuidebookLabelText>{labelNode}</GuidebookLabelText>
        <GuidebookInfoIcon src={STATIC_IMAGE_URLS.icons.infoV2} alt="" data-testid="guidebook-info-icon" />
      </GuidebookLabelWrapper>
    );
  }

  return (
    <>
      <GuidebookLabelWrapper
        data-testid="guidebook-label-wrapper"
        data-tooltip-id="guidebook-tooltip"
        data-tooltip-place="top"
        data-tooltip-offset={8}
      >
        <GuidebookLabelText>{labelNode}</GuidebookLabelText>
        <GuidebookInfoIcon src={STATIC_IMAGE_URLS.icons.infoV2} alt="" data-testid="guidebook-info-icon" />
      </GuidebookLabelWrapper>

      <GuidebookTooltip id="guidebook-tooltip" place="top" opacity={1} arrowColor={COLORS.WHITE}>
        <span>{tooltipNode}</span>
      </GuidebookTooltip>
    </>
  );
};
